import React from "react";
import InfoIcon from "../../../images/info.png";

const DeliveryOrderTotal = (props) => {
  let { currency_code } = props.orderTotal;
  const refoundAmount = props.orderTotal.refund_amount
    ? parseFloat(props.orderTotal.refund_amount).toFixed(3)
    : 0 + props.orderTotal.total_refunded
      ? parseFloat(props.orderTotal.total_refunded).toFixed(3)
      : 0;
  console.log("goooooo", props.orderTotal, refoundAmount);

  let refusedItems =
    props.orderTotal &&
    props.orderTotal.order_items.delivered.filter((order) => {
      if (order.qty_refused && order.qty_refused > 0) {
        return order;
      }
    });
  let refusedQty =
    refusedItems &&
    refusedItems.length > 0 &&
    refusedItems
      .map((item) => item.qty_refused)
      .reduce((prev, next) => prev + next);
  console.log("goooooo1", refusedItems, refusedQty);
  const toPayValue = (
    parseFloat(props.orderTotal.amount_to_be_collected) -
    parseFloat(refoundAmount)
  ).toFixed(3);
  return (
    <div className="order_totals_container p-3">
      <div className="row">
        {/* <div className="col-3">
          Item(s) : <p className="count">{props.orderTotal.total_item_count}</p>
        </div>
        <div className="col-3">
          T. Qty:{" "}
          <p className="count">
            {parseInt(props.orderTotal.total_qty_ordered)}
          </p>
        </div> */}
        <div className="deliverItem_totals_block">
          <div className="deliveryItemAmount">
            <span>
              Subtotal <br /> ({props.orderTotal.total_item_count} Items,{" "}
              {parseFloat(props.orderTotal.total_qty_ordered).toFixed(3)}qty)
            </span>{" "}
            <span className="count">{` ${currency_code}${(
              parseFloat(props.orderTotal.order_amount) -
              parseFloat(props.orderTotal.shipping_amount)
            ).toFixed(3)}`}</span>
          </div>
          {/* <br /> */}
          <div className="deliveryItemAmount">
            <span className="order_totals_label">Shiping:</span>{" "}
            <span className="count">
              {currency_code}{" "}
              {parseFloat(props.orderTotal.shipping_amount).toFixed(3)}
            </span>
          </div>
          {/* <br /> */}
          {/* <div className="deliveryItemAmount">
            <span className="order_totals_label">Discount:</span>{" "}
            <span className="count">
              -{currency_code}{" "}
              {parseFloat(props.orderTotal.discount_amount).toFixed(3)}
            </span>
          </div> */}
          {<br />}
          {<div className="deliveryItemAmount">
            <span className="order_totals_label">Loyalty Discount:</span>{" "}
            <span className="count">
              -{currency_code}{" "}
              {parseFloat(props.orderTotal.loyalty_discount).toFixed(3)}
            </span>
          </div>}
          <div className="deliveryItemAmount">
            <span className="order_totals_label">Amount Paid:</span>{" "}
            <span className="count">
              {currency_code}{" "}
              {(props.orderTotal.amount_collected
                ? parseFloat(props.orderTotal.amount_collected)
                : 0
              ).toFixed(3)}
            </span>
          </div>
          {/* <div className="deliveryItemAmount">
            <span className="order_totals_label">Amount Refunded OOS:</span>{" "}
            <span className="count">
              -{currency_code}{" "}
              {parseFloat(props.orderTotal.oos_refund).toFixed(3)}
            </span>
          </div> */}
          {/* <br /> */}
          {/* <div className="deliveryItemAmount">
            <span className="order_totals_label">Promo Cash:</span>{" "}
            <span className="count">
              -{currency_code}{" "}
              {parseFloat(props.orderTotal.promo_cash).toFixed(3)}
            </span>
          </div> */}
          <div className="singleLine"></div>

          <div className="deliveryItemAmount deliveryItemAmountTotalAmnt amntBold">
            <span className="order_totals_label amntBold">Total Amount:</span>{" "}
            <span>
              {currency_code}{" "}
              {(props.orderTotal.amount_to_be_collected > 0
                ? parseFloat(props.orderTotal.amount_to_be_collected)
                : 0
              ).toFixed(3)}
            </span>
          </div>
          <div className="singleLine thickDivider"></div>

          {/* <br /> */}
          {/* <span className="order_totals_label">Wallet Amount:</span>{" "}
          <span className="count">
            -{currency_code}
            {props.orderTotal.wallet_amount}
          </span> */}
          {/* <br /> */}

          {parseFloat(props.orderTotal.refund_amount).toFixed(3) > 0 ||
            props.orderTotal.total_refunded ? (
            <div className="deliveryItemAmount returnedAmnt amntBold">
              <span className="amntBold">
                Returned Amount <br />{" "}
                <span className="returnedAmntItems">
                  ({refusedItems.length} Items,{" "}
                  {parseFloat(refusedQty).toFixed(3)} qty):
                </span>
              </span>

              <span className="info_icon ml-3">
                {/* <img src={InfoIcon} alt="Info" /> */}
                {parseFloat(refoundAmount).toFixed(3)}
              </span>
            </div>
          ) : (
            ""
          )}
          {(parseFloat(props.orderTotal.refund_amount).toFixed(3) > 0 ||
            props.orderTotal.total_refunded) && (
              <div className="singleLine thickDivider"></div>
            )}

          {parseFloat(props.orderTotal.refund_amount).toFixed(3) > 0 ||
            props.orderTotal.total_refunded ? (
            <div className="deliveryItemAmount toPayAmnt amntBold">
              <span className="amntBold">To Pay: </span>

              <span className="info_icon ml-3">
                {/* <img src={InfoIcon} alt="Info" /> */}
                {currency_code}{" "}
                {toPayValue > 0 ? toPayValue : parseFloat(0).toFixed(3)}
              </span>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>

      {/* <div className="grand_totals_container pb-2 pt-2 mt-3">
        <div className="row">
          <div className="col-6 text-left">Grand Total :</div>
          <div className="col-6 text-right">
            {currency_code}
            {props.orderTotal.grand_total}
          </div>
        </div>
      </div> */}
    </div>
  );
};
export default DeliveryOrderTotal;



// WEBPACK FOOTER //
// ./src/components/Intransit/DeliverOrder/DeliveryOrderTotal.js